import axios from 'axios'
export const fetchData = async (url, method, payload) => {
  try {
    const response = payload ? await axios[method](url) : await axios[method](url, payload);
    return response.data
  } catch (error) {
    return {error}
  }
}